import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  initialized: false,
};

export const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    initialize: state => {
      state.initialized = true;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { initialize, setLoading } = statusSlice.actions;

export default statusSlice.reducer;
